import {DashboardService} from '../../../../../service/events/dashboard.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseForm} from '../../../../base-form';
import {FincasApiService} from '../../../../../service/api/fincas-api.service';
import {build, pool} from '../../../../../common/classes/request-builder';
import { environment } from '../../../../../../environments/environment';

import { SectorModel } from '../../../../../models/form-common/sector.model';
import { RequestButtonComponent } from '../../../../../common/components/request-button/request-button.component';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { FormRequestTypes } from '../../../../../common/classes/form-request';
import { SectoresFormDefinition } from './form-definition';
import { HttpClient } from '@angular/common/http';
import { FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-sector-form',
    standalone: false,
    templateUrl: './sector-form.component.html',
    styleUrls: ['./sector-form.component.scss']
})
export class SectorFormComponent extends BaseForm<SectorModel> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
        requestButton = new RequestButtonComponent<SectorModel>();

    @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<SectorModel>;

    public form!: SectoresFormDefinition;

    public formRequest = new ReactiveFormBuilderComponent(this.http);

    /** Emits when dropdowns are ready to be reloaded */
    public readonly dropdownLoadTrigger = new Subject<void>();

    public readonly FormRequestTypes = FormRequestTypes;
    
    override pathToGoBack = 'sectores';

    override model = {} as SectorModel;


    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public override dashboard: DashboardService,
        public fincasApi: FincasApiService,
        private readonly http: HttpClient
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi.sectoresPUT,
            fincasApi.sectoresPOST,
            'sectores',
            'Actualizar ' + environment.features.sectorName,
            'Crear ' + environment.features.sectorName
        );
    }

    ngOnInit(): void {
        this.form = new SectoresFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            null
        );
        
        this.initFormData();
        
        this.formRequest.executePhase(FormPhase.LOAD);

        this.softInit(this.getType());
    }

    public formChanges(formModel: object, _tag: string): void {
        this.form.model = formModel as SectorModel;
    }


    private initFormData(): Promise<boolean> {
        const builds = [
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre'),
            build(this.fincasApi.parcelasGET, this.form.lists.jardines, 'nombre')
        ];

        const notify = (): void => { 
            queueMicrotask(() => { 
                this.dropdownLoadTrigger.next();         
                this.formBuilder.updateForm(this.form.model, true); 
            }); 
        };

        if (builds.length === 0) {
            notify();
            return Promise.resolve(true);
        }

        return pool(builds, notify);
    }
}